import { StyleSheet, Platform } from 'react-native'
import { theme } from '../../../theme'
import { WEB_HOVER_TRANSITION } from '../../../src/shared/constants/animations'

export const legalDocumentScreenStyles = StyleSheet.create({
  webPageRoot: {
    width: '100%' as never,
    minHeight: '100vh' as never,
    backgroundColor: theme.background.card,
  },
  container: {
    flex: 1,
    backgroundColor: theme.background.card,
    ...(Platform.OS === 'web' && {
      minHeight: '100vh' as never,
    }),
  },
  /**
   * Web: root layout uses body/document scroll (see usePublicMarketingWebScrollLayout).
   * A bounded flex ScrollView often does not scroll reliably under RN Web + #root { display:flex; height:100% }.
   */
  webDocumentRoot: {
    width: '100%',
    minHeight: '100vh' as never,
    backgroundColor: theme.background.card,
    paddingHorizontal: 24,
    paddingTop: 48,
    paddingBottom: 64,
    maxWidth: 720,
    alignSelf: 'center',
  },
  contentContainer: {
    flexGrow: 1,
    paddingHorizontal: Platform.OS === 'web' ? 24 : 20,
    paddingTop: Platform.OS === 'web' ? 48 : 40,
    paddingBottom: Platform.OS === 'web' ? 64 : 48,
    maxWidth: 720,
    width: '100%',
    alignSelf: 'center',
  },
  backLink: {
    alignSelf: 'flex-start',
    marginBottom: Platform.OS === 'web' ? 28 : 24,
    paddingVertical: 8,
    paddingHorizontal: 4,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer' as never,
      transition: WEB_HOVER_TRANSITION as never,
    }),
  },
  backLinkPressed: {
    opacity: 0.75,
  },
  backLinkHovered: {
    opacity: 0.9,
  },
  backLinkText: {
    fontSize: Platform.OS === 'web' ? 16 : 15,
    fontWeight: '600',
    color: theme.primaryLight,
  },
  title: {
    fontSize: Platform.OS === 'web' ? 36 : 28,
    fontWeight: '800',
    color: theme.white,
    marginBottom: Platform.OS === 'web' ? 12 : 10,
    textAlign: 'left',
  },
  versionLine: {
    fontSize: Platform.OS === 'web' ? 15 : 13,
    fontWeight: '400',
    color: theme.gray[500],
    marginBottom: Platform.OS === 'web' ? 32 : 24,
    textAlign: 'left',
  },
  titleOnly: {
    marginBottom: Platform.OS === 'web' ? 32 : 24,
  },
  section: {
    marginBottom: Platform.OS === 'web' ? 28 : 22,
  },
  sectionTitle: {
    fontSize: Platform.OS === 'web' ? 20 : 18,
    fontWeight: '700',
    color: theme.white,
    marginBottom: Platform.OS === 'web' ? 12 : 10,
  },
  paragraph: {
    fontSize: Platform.OS === 'web' ? 17 : 15,
    fontWeight: '400',
    color: theme.gray[600],
    lineHeight: Platform.OS === 'web' ? 28 : 24,
    marginBottom: Platform.OS === 'web' ? 12 : 10,
  },
  privacyControlsCallout: {
    marginBottom: Platform.OS === 'web' ? 28 : 22,
    padding: 14,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: theme.gray[300],
    backgroundColor: theme.background.cardElevated,
  },
  privacyControlsCalloutText: {
    fontSize: Platform.OS === 'web' ? 15 : 14,
    color: theme.gray[600],
    marginBottom: 10,
  },
  privacyControlsLink: {
    alignSelf: 'flex-start',
    paddingVertical: 6,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer' as never,
      transition: WEB_HOVER_TRANSITION as never,
    }),
  },
  privacyControlsLinkPressed: {
    opacity: 0.75,
  },
  privacyControlsLinkHovered: {
    opacity: 0.9,
  },
  privacyControlsLinkText: {
    color: theme.primaryLight,
    fontSize: Platform.OS === 'web' ? 15 : 14,
    fontWeight: '600',
  },
})
